import * as S from './Bid.styled';
import { useId } from 'react';
import { CustomInput } from 'components';
import PropTypes from 'prop-types';
import { ErrorMarker } from 'assets/icons';
import uuid from 'react-uuid';

const Big = ({
  label,
  value = '',
  onChange,
  onFocus = () => {},
  onBlur = () => {},
  error,
  errorMesage,
  withError = true,
  style,
  width = 70,
  placeholder,
}) => {
  return (
    <S.BigContainer style={style}>
      <S.Wrap>
        {label && <S.Label>{label}</S.Label>}
        <S.BigWrap>
          <S.Currency>$</S.Currency>
          <CustomInput
            placeholder={placeholder}
            type='number'
            withLabel
            id={`big_input_${uuid()}`}
            name={`big_input_${uuid()}`}
            value={value ?? ''}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            width={width}
            error={error}
          />
        </S.BigWrap>
      </S.Wrap>
      {withError && (
        <S.ErrorWrap big>
          {error && (
            <>
              {errorMesage && <ErrorMarker />}
              <S.ErrorText>{errorMesage}</S.ErrorText>
            </>
          )}
        </S.ErrorWrap>
      )}
    </S.BigContainer>
  );
};

const Small = ({
  label,
  value = '',
  onChange,
  onFocus = () => {},
  onBlur = () => {},
  error,
  errorMesage,
  style,
  width = 48,
  labelWidth = 81,
}) => {
  const name_id = useId();
  return (
    <S.SmallContainer style={style}>
      <S.SmallWrap>
        <S.LabelCurrency style={{ minWidth: labelWidth }}>{`${label}: $`}</S.LabelCurrency>
        <S.InputWrapp>
          <CustomInput
            name={name_id}
            type='number'
            withLabel
            id='small_input'
            value={value ?? ''}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            width={width}
            error={error}
          />
        </S.InputWrapp>
      </S.SmallWrap>
      <S.ErrorWrap>
        {error && (
          <>
            {errorMesage && <ErrorMarker />}
            <S.ErrorText>{errorMesage}</S.ErrorText>
          </>
        )}
      </S.ErrorWrap>
    </S.SmallContainer>
  );
};

const Bid = { Big, Small };

const types = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
};

Big.propTypes = types;
Small.propTypes = types;

export default Bid;
